module.exports = __webpack_public_path__ + "img/p25.4db2acbb.gif";